export default __webpack_public_path__ + "static/media/mc_front_empty.e270cfc1.svg";